import { render } from "./MailTemplate.vue?vue&type=template&id=029a43d3&scoped=true"
import script from "./MailTemplate.vue?vue&type=script&lang=js"
export * from "./MailTemplate.vue?vue&type=script&lang=js"

import "./MailTemplate.vue?vue&type=style&index=0&id=029a43d3&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-029a43d3"]])

export default __exports__